import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment.prod';

const host = window.location.hostname;

// Configuración para desarrollo local con Docker
const isLocalDevelopment = host === 'localhost' || host === '127.0.0.1';

if (isLocalDevelopment) {
  // DESARROLLO LOCAL - Docker backend en puerto 8080
  // environment.base = `http://localhost:4200`;
  // environment.baseAvatar = `http://localhost:8080/assets/avatar/`;
  // environment.baseUrl = `http://localhost:8080`;
  // environment.baseAssetsUrl = `http://localhost:8080/assets/`;

  // DESARROLLO LOCAL - con servidor remoto
  environment.base = `https://desarrollo.becompliance.tech`;
  environment.baseAvatar = `https://desarrollo.becompliance.tech/backend/assets/avatar/`;
  environment.baseUrl = `https://desarrollo.becompliance.tech/backend`;
  environment.baseAssetsUrl = `https://desarrollo.becompliance.tech/backend/assets/`;
} else {
  // PRODUCCIÓN - Servidor remoto
  environment.base = `https://${host}`;
  environment.baseAvatar = `https://${host}/backend/assets/avatar/`;
  environment.baseUrl = `https://${host}/backend`;
  environment.baseAssetsUrl = `https://${host}/backend/assets/`;
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
